/* ==========================================================================
   LINDIE — Audio Sample Preview
   Global fetchAudioUrl + floating mini-player (cards) + PDP inline player
   ========================================================================== */
(function () {
  'use strict';

  /* ── Demo fallback URL (used when Lambda is not yet configured) ─────────── */
  var DEMO_URL = 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3';

  /* ── Shared: fetch presigned URL from Lambda (or return demo URL) ────────── */
  function fetchAudioUrl(isbn) {
    var lambdaUrl = window.lindiePreviewUrl;

    if (lambdaUrl) {
      return fetch(lambdaUrl + '?isbn=' + encodeURIComponent(isbn), {
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (body) {
              var msg = (body && body.error) ? body.error : ('HTTP ' + r.status);
              var err = new Error(msg);
              err.status = r.status;
              throw err;
            }).catch(function (e) { if (e.status) throw e; throw new Error('HTTP ' + r.status); });
          }
          return r.json();
        })
        .then(function (data) {
          if (!data.url) throw new Error('No URL in response');
          return data.url;
        });
    }

    /* Demo mode — simulate network delay */
    return new Promise(function (resolve) {
      setTimeout(function () { resolve(DEMO_URL); }, 800);
    });
  }

  /* expose globally so lindie-audio-player.js can call it */
  window.lindieGetAudioUrl = fetchAudioUrl;

  /* ════════════════════════════════════════════════════════════════════════
     FLOATING MINI-PLAYER  (product cards, collection, homepage, etc.)
     ════════════════════════════════════════════════════════════════════════ */

  /* ── Build mini-player DOM ──────────────────────────────────────────────── */
  function buildPlayer() {
    var el = document.createElement('div');
    el.id = 'LindieMiniPlayer';
    el.className = 'lindie-mini-player';
    el.setAttribute('aria-label', 'Audio preview player');
    el.setAttribute('role', 'region');
    el.innerHTML =
      '<div class="lindie-mini-player__inner">' +
        '<div class="lindie-mini-player__info">' +
          '<svg class="lindie-mini-player__headphones" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>' +
          '<div class="lindie-mini-player__text">' +
            '<span class="lindie-mini-player__label" id="LindieMiniLabel">Sample Preview</span>' +
            '<span class="lindie-mini-player__title" id="LindieMiniTitle"></span>' +
          '</div>' +
        '</div>' +
        '<div class="lindie-mini-player__controls">' +
          '<button class="lindie-mini-player__play-btn" id="LindieMiniPlay" aria-label="Play">' +
            '<svg class="lmp-icon-play" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' +
            '<svg class="lmp-icon-pause" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="display:none"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>' +
            '<span class="lmp-icon-loading" style="display:none"></span>' +
          '</button>' +
          '<div class="lindie-mini-player__track">' +
            '<div class="lindie-mini-player__progress-bg">' +
              '<div class="lindie-mini-player__progress-fill" id="LindieMiniProgress"></div>' +
            '</div>' +
            '<div class="lindie-mini-player__time">' +
              '<span id="LindieMiniCurrent">0:00</span>' +
              '<span id="LindieMiniDuration">0:00</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button class="lindie-mini-player__close" id="LindieMiniClose" aria-label="Close preview">' +
          '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="4" x2="16" y2="16"/><line x1="16" y1="4" x2="4" y2="16"/></svg>' +
        '</button>' +
      '</div>' +
      '<audio id="LindieMiniAudio" preload="none"></audio>';
    document.body.appendChild(el);
    return el;
  }

  /* ── Time formatting ────────────────────────────────────────────────────── */
  function formatTime(secs) {
    if (isNaN(secs) || !isFinite(secs)) return '0:00';
    var m = Math.floor(secs / 60);
    var s = Math.floor(secs % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* ── Player state ───────────────────────────────────────────────────────── */
  var player, audio, playBtn, closeBtn, progressFill, currentEl, durationEl, titleEl, labelEl;
  var currentIsbn = null;
  var currentTitle = '';
  var isLoading = false;

  function initRefs() {
    if (player) return;
    player       = buildPlayer();
    audio        = document.getElementById('LindieMiniAudio');
    playBtn      = document.getElementById('LindieMiniPlay');
    closeBtn     = document.getElementById('LindieMiniClose');
    progressFill = document.getElementById('LindieMiniProgress');
    currentEl    = document.getElementById('LindieMiniCurrent');
    durationEl   = document.getElementById('LindieMiniDuration');
    titleEl      = document.getElementById('LindieMiniTitle');
    labelEl      = document.getElementById('LindieMiniLabel');
    bindPlayerEvents();
  }

  function setLabel(text) {
    if (labelEl) labelEl.textContent = text;
  }

  function setLoadingState(loading) {
    isLoading = loading;
    var iconPlay    = playBtn.querySelector('.lmp-icon-play');
    var iconPause   = playBtn.querySelector('.lmp-icon-pause');
    var iconLoading = playBtn.querySelector('.lmp-icon-loading');
    iconPlay.style.display    = loading ? 'none' : (audio.paused ? '' : 'none');
    iconPause.style.display   = loading ? 'none' : (audio.paused ? 'none' : '');
    iconLoading.style.display = loading ? '' : 'none';
    playBtn.disabled = loading;
    if (loading) {
      player.classList.add('lindie-mini-player--loading');
      setLabel('Loading\u2026');
      titleEl.textContent = currentTitle;
      currentEl.textContent  = '--:--';
      durationEl.textContent = '--:--';
    } else {
      player.classList.remove('lindie-mini-player--loading');
      /* Sync play/pause state now that metadata is ready */
      setPlayingState(!audio.paused);
    }
  }

  function setPlayingState(playing) {
    var iconPlay  = playBtn.querySelector('.lmp-icon-play');
    var iconPause = playBtn.querySelector('.lmp-icon-pause');
    iconPlay.style.display  = playing ? 'none' : '';
    iconPause.style.display = playing ? '' : 'none';
    playBtn.disabled = false;
    playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    setLabel(playing ? 'Now Playing' : 'Paused');
  }

  function resetProgress() {
    progressFill.style.width = '0%';
    currentEl.textContent = '0:00';
    durationEl.textContent = '0:00';
  }

  function bindPlayerEvents() {
    audio.addEventListener('timeupdate', function () {
      if (!audio.duration) return;
      var pct = (audio.currentTime / audio.duration) * 100;
      progressFill.style.width = pct + '%';
      currentEl.textContent = formatTime(audio.currentTime);
    });

    audio.addEventListener('loadedmetadata', function () {
      durationEl.textContent = formatTime(audio.duration);
      setLoadingState(false);
    });

    audio.addEventListener('play',  function () { if (!isLoading) setPlayingState(true); });
    audio.addEventListener('pause', function () { if (!isLoading) setPlayingState(false); });

    audio.addEventListener('ended', function () {
      setPlayingState(false);
      resetProgress();
      audio.currentTime = 0;
    });

    audio.addEventListener('error', function () {
      setLoadingState(false);
      setPlayingState(false);
      setLabel('Sample Preview');
      titleEl.textContent = currentTitle;
      console.error('LINDIE preview: audio error');
    });

    playBtn.addEventListener('click', function () {
      if (audio.paused) { audio.play(); } else { audio.pause(); }
    });

    /* Click on progress bar to seek */
    var progressBg = player.querySelector('.lindie-mini-player__progress-bg');
    progressBg.addEventListener('click', function (e) {
      if (!audio.duration) return;
      var rect = progressBg.getBoundingClientRect();
      var pct = (e.clientX - rect.left) / rect.width;
      audio.currentTime = Math.max(0, Math.min(1, pct)) * audio.duration;
    });

    closeBtn.addEventListener('click', closePlayer);
  }

  /* ── Card preview button — loading state ────────────────────────────────── */
  function setCardBtnLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.origText = btn.innerHTML;
      btn.innerHTML = '<span class="lmp-card-spinner"></span>';
      btn.disabled = true;
    } else {
      if (btn.dataset.origText) btn.innerHTML = btn.dataset.origText;
      btn.disabled = false;
    }
  }

  /* ── Open / close player ────────────────────────────────────────────────── */
  function openPlayer(isbn, title, triggerBtn) {
    initRefs();

    /* Same ISBN — toggle play/pause */
    if (isbn === currentIsbn && audio.src) {
      player.classList.add('lindie-mini-player--open');
      if (audio.paused) { audio.play(); } else { audio.pause(); }
      return;
    }

    currentIsbn  = isbn;
    currentTitle = title || isbn;
    player.classList.add('lindie-mini-player--open');
    setLoadingState(true);
    resetProgress();

    /* Stop previous audio */
    audio.pause();
    audio.src = '';

    /* Show spinner on card button */
    setCardBtnLoading(triggerBtn, true);

    fetchAudioUrl(isbn)
      .then(function (url) {
        setCardBtnLoading(triggerBtn, false);
        audio.src = url;
        audio.load();
        return audio.play();
      })
      .catch(function (err) {
        setCardBtnLoading(triggerBtn, false);
        var msg = (err && err.status === 404) ? 'No preview available' : 'Preview unavailable';
        setLoadingState(false);
        player.classList.remove('lindie-mini-player--loading');
        setLabel(msg);
        titleEl.textContent = currentTitle;
        playBtn.style.display = 'none';
        /* Auto-close after 2.5 s */
        setTimeout(function () {
          playBtn.style.display = '';
          closePlayer();
        }, 2500);
        console.warn('LINDIE preview:', err.message || err);
      });
  }

  function closePlayer() {
    if (!player) return;
    audio.pause();
    player.classList.remove('lindie-mini-player--open');
    player.classList.remove('lindie-mini-player--loading');
    setLabel('Sample Preview');
    currentIsbn  = null;
    currentTitle = '';
  }

  /* ── Event delegation — product card Preview buttons ────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lindie-product-card__preview-link');
    if (!btn) return;
    e.preventDefault();
    var isbn  = btn.dataset.isbn;
    var title = btn.dataset.title || '';
    if (isbn) openPlayer(isbn, title, btn);
  });

  /* ════════════════════════════════════════════════════════════════════════
     PDP INLINE PLAYER
     lindie-audio-player.js handles waveform + play/pause AFTER first load.
     We intercept the first click here to fetch the URL first.
     ════════════════════════════════════════════════════════════════════════ */
  function initPdpPlayer() {
    var container = document.querySelector('[data-audio-player]');
    if (!container) return;

    var pdpAudio = container.querySelector('.js-pdp-audio');
    if (!pdpAudio) return;

    var isbn = pdpAudio.dataset.isbn;
    if (!isbn) return;

    var pdpPlayBtn = container.querySelector('.js-pdp-play');
    if (!pdpPlayBtn) return;

    var fetched = false;

    pdpPlayBtn.addEventListener('click', function handleFirstPlay() {
      if (fetched) return; /* lindie-audio-player.js handles subsequent clicks */
      fetched = true;

      /* Show spinner on PDP play button */
      var iconPlay    = pdpPlayBtn.querySelector('.pdp-player__icon-play');
      var iconPause   = pdpPlayBtn.querySelector('.pdp-player__icon-pause');
      var iconLoading = pdpPlayBtn.querySelector('.pdp-player__icon-loading');

      if (iconPlay)    iconPlay.style.display    = 'none';
      if (iconPause)   iconPause.style.display   = 'none';
      if (iconLoading) iconLoading.style.display = '';
      pdpPlayBtn.disabled = true;

      fetchAudioUrl(isbn)
        .then(function (url) {
          pdpAudio.src = url;
          pdpAudio.load();
          return pdpAudio.play();
        })
        .then(function () {
          /* Restore icons — lindie-audio-player.js takes over from here */
          if (iconPlay)    iconPlay.style.display    = 'none';
          if (iconPause)   iconPause.style.display   = '';
          if (iconLoading) iconLoading.style.display = 'none';
          pdpPlayBtn.disabled = false;
        })
        .catch(function (err) {
          fetched = false; /* allow retry */
          if (iconPlay)    iconPlay.style.display    = '';
          if (iconPause)   iconPause.style.display   = 'none';
          if (iconLoading) iconLoading.style.display = 'none';
          pdpPlayBtn.disabled = false;
          console.error('LINDIE PDP preview error:', err);
        });
    }, { once: false });
  }

  document.addEventListener('DOMContentLoaded', initPdpPlayer);

})();
